import { employees, getEmployee } from "../../models/employees";

export default function EmployeeSelect({
  selectedEmployee,
  onSelectedEmployee,
  hiddenEmployeeIds,
  className,
}) {
  return (
    <select
      className={className}
      value={selectedEmployee.id}
      onChange={(e) =>
        onSelectedEmployee(getEmployee(parseInt(e.target.value)))
      }
    >
      {employees.map((employee) => {
        if (hiddenEmployeeIds && hiddenEmployeeIds.includes(employee.id)) {
          return null;
        }
        return (
          <option key={employee.id} value={employee.id}>
            <b style={{ fontWeight: "600" }}>{employee.name} - {employee.level.toUpperCase()}</b>
          </option>
        );
      })}
    </select>
  );
}
